<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="300" @click:outside="$emit('close')">
      <v-card>
        <v-card-title>Alert</v-card-title>
        <v-card-text>Are you sure you want to remove this listing?</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="error" @click="$emit('close')">No</v-btn>
          <v-btn text color="success" @click="$emit('click')">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialog: true
    };
  }
};
</script>
